import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  PERSONAL_FINANCE = 'Personal Finance',
  MORTGAGES = 'Mortgages',
  CREDIT = 'Credit',
  SAVINGS = 'Savings',
  RETIREMENT = 'Retirement',
  TAXES = 'Taxes',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['personal-finance'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['personal-finance/mortgages'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['personal-finance/credit'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['personal-finance/savings'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['personal-finance/retirement'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['personal-finance/taxes'] } }
    ]
  }
};

const MORTGAGES = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['personal-finance/mortgages'] } }]
  }
};

const CREDIT = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['personal-finance/credit'] } }]
  }
};

const SAVINGS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['personal-finance/savings'] } }]
  }
};

const RETIREMENT = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['personal-finance/retirement'] } }]
  }
};

const TAXES = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['personal-finance/taxes'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: [
            'personal-finance',
            'personal-finance/mortgages',
            'personal-finance/credit',
            'personal-finance/savings',
            'personal-finance/retirement',
            'personal-finance/taxes'
          ]
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [
      { term: { key: 'DJEThing', value: 'personal-finance' } },
      { prefix: { key: 'DJEThing', value: 'personal-finance/' } }
    ],
    not: []
  }
};

export { MAIN, SECTION_ENUM, MORTGAGES, CREDIT, SAVINGS, RETIREMENT, TAXES, RELATED_OPINION, VIDEO };
